import { render, staticRenderFns } from "./DashboardListHeader.vue?vue&type=template&id=24cc410f&scoped=true&"
import script from "./DashboardListHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardListHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashboardListHeader.vue?vue&type=style&index=0&id=24cc410f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc410f",
  null
  
)

export default component.exports